// Looping muted background video with a gradient scrim on top.
export function VideoBackdrop({ src, testId, layerClass = "", overlayClass = "" }) {
  return (
    <>
      <video
        data-testid={testId}
        className={`pointer-events-none absolute inset-0 h-full w-full object-cover ${layerClass}`}
        src={src}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
      />
      <div aria-hidden="true" className={`absolute inset-0 ${overlayClass}`} />
    </>
  );
}
